import { imageDoesExist } from "../../../utils/getImages";
export class PositionPartnerBuilderResponse {
  data: any;
  type: number;
}

export default class PositionPartner {
  name: string;
  id: string;
  typeId: number;
  isChecked: boolean;
  positionId: number;
  data: object;

  /**
   *
   */
  constructor(
    name: string,
    id: string,
    typeId: number,
    data: object,
    isChecked: boolean
  ) {
    this.name = name;
    this.id = id;
    this.typeId = typeId;
    this.isChecked = isChecked;
    this.data = data;
  }

  setPositionId(id: number) {
    this.positionId = id;
  }
}
export class PlatsbankenPartner extends PositionPartner {
  data: {
    senderId: string;
  } = { senderId: "" };

  constructor(id: string, senderId: string, data: object, isChecked: boolean) {
    super("Platsbanken", id, 3, data, isChecked);
    this.data.senderId = senderId;
  }
}
export class PlatsbankenPartnerPublishModel extends PositionPartner {
  data: {
    qualificationCategory: string;
    occupationId: string;
    cityId: string
    salaryMontly: number;
    salaryDescription: string;
    transactionId: string;
    address: string;
    city: string;
    zipCode: string;
    countryCode: string;
    positionSummary: string;
    // positionScheduleSummary: string; // Removed - not supported by Direct Transfer API
    scheduleTimeType: string;
    regularTimeType: string;
    temporaryTimeLength: number;
    // durationSummaryText: string; // Removed - not supported by Direct Transfer API
    qualificationType: string;
    // qualificationDescriptionType: string; // Removed - 'Egen bil' option not supported
    qualificationYearsOfExperince: number;
  } = {
    salaryDescription: "",
    countryCode: "SE",
    transactionId: "",
    address: "",
    city: "",
    zipCode: "",
    positionSummary: "",
    cityId: "",
    salaryMontly: 0,
    // positionScheduleSummary: "", // Removed - not supported by Direct Transfer API
    scheduleTimeType: "",
    regularTimeType: "",
    temporaryTimeLength: 0,
    // durationSummaryText: "", // Removed - not supported by Direct Transfer API
    occupationId: "",
    qualificationCategory: "",
    qualificationType: "",
    // qualificationDescriptionType: "", // Removed - 'Egen bil' option not supported
    qualificationYearsOfExperince: 0,
  };

  constructor(id: string, data: any, isChecked: boolean) {
    super("Platsbanken", id, 3, data, isChecked);
    if (!data) {
      data = {
        transactionId: "",
        address: "",
        city: "",
        zipCode: "",
        summary: "",
      };
    } else this.data = data;
  }
}
export class BlocketPartnerPublishModel extends PositionPartner {
  type: number;
  data: {
    categoryId: number;
    categorySubId: number;
    employmentId: number;
    jobAdId: number;
    regionId: number;
    regionSubId: number;
    productId: string;
    summary: string;
  } = {
    categoryId: 0,
    categorySubId: 0,
    employmentId: 0,
    jobAdId: 0,
    regionId: 0,
    regionSubId: 0,
    productId: "",
    summary: "",
  };
  constructor(id: string, data: any, isChecked: boolean) {
    super("Blocket", id, 2, data, isChecked);
    if (!data) {
      data = {
        categoryId: 0,
        categorySubId: 0,
        employmentId: 0,
        jobAdId: 0,
        regionId: 0,
        regionSubId: 0,
        productId: "",
        summary: "",
      };
    } else this.data = data;
  }
}

export class BlocketPartnerSetting extends PositionPartner {
  data: {
    vatId: string;
  } = { vatId: "" };

  constructor(id: string, data: any, isChecked: boolean) {
    super("Blocket", id, 2, data, isChecked);
    if (!data) {
      data = {
        vatId: "",
      };
    } else this.data = data;
  }
}

export class LedigajobbPartner extends PositionPartner {
  data: {
    apiKey: string;
  } = { apiKey: "" };

  constructor(id: string, apiKey: string, data: object, isChecked: boolean) {
    super("Ledigajobb.se", id, 4, data, isChecked);
    this.data.apiKey = apiKey;
  }
}

export class LedigajobbPartnerPublishModel extends PositionPartner {
  data: {
    externalId: string;
    title: string;
    positions: number;
    publishDate: string;
    lastPublishDate: string;
    jobDescriptionText: string;
    profession: string;
    workplaceLocation: {
      city: number;
    };
    applicationURL: string;
    applicationDetails: string;
    homepageURL: string;
    employmentVariations: string[];
    tags: string[];
    workHours: string;
  } = {
    externalId: "",
    title: "",
    positions: 1,
    publishDate: "",
    lastPublishDate: "",
    jobDescriptionText: "",
    profession: "",
    workplaceLocation: {
      city: 0
    },
    applicationURL: "",
    applicationDetails: "",
    homepageURL: "",
    employmentVariations: ["unset"],
    tags: [],
    workHours: "fullTime"
  };

  constructor(id: string, data: any, isChecked: boolean) {
    super("Ledigajobb.se", id, 4, data, isChecked);
    if (!data) {
      data = {
        externalId: "",
        title: "",
        positions: 1,
        publishDate: "",
        lastPublishDate: "",
        jobDescriptionText: "",
        profession: "",
        workplaceLocation: {
          city: 0
        },
        applicationURL: "",
        applicationDetails: "",
        homepageURL: "",
        employmentVariations: ["unset"],
        tags: [],
        workHours: "fullTime"
      };
    } else {
      this.data = data;
    }
  }
}
